import { init as initAPM } from '@elastic/apm-rum';

initAPM({
	apiVersion: 3,
	serviceName: 'fs-blacklight-client',
	serverUrl: window.apmConfig.url,
	active: window.apmConfig.active,
	centralConfig: window.apmConfig.centralConfig,
	transactionSampleRate: window.apmConfig.transactionSampleRate,
	distributedTracingOrigins: window.apmConfig.traceOrigins,
	propagateTracestate: true,
	flushInterval: 200,
});

if (window.apmConfig.active) {
	var origError = console.error;
	console.error = function (error) {
		try {
			if (typeof error === 'string' || error instanceof Error) {
				elasticApm.captureError(error);
			}
		} finally {
			origError.apply(console, arguments);
		}
	};
}
